<div *ngIf="isAutomated" class="d-flex align-items-center automation-warning p-10 mt-10 mb-10">
  <i class="icon-ico_eye_off automated-icon top-message me-2"></i>
  Automated decision has been enabled. This page was hidden from end-users.
</div>
<ey-froala-content-wrapper [editorContent]="body"></ey-froala-content-wrapper>
<ul class="ps-0 mt-10">
  <li *ngFor="let op of options" [ngClass]="{ selected: op.selected }"><i class="icon-ico_check emp-icon"></i>{{ op.description }}</li>
</ul>
